import Discount from ".";

export const discountRoutes = (data) => [
  {
    path: "admin/coupons",
    title: "Coupons",
    layout: "admin",
    routeType: "admin",
    component: Discount,
  },
];
